let parseAllowlistFromEnv = (): string[] => {
  let raw = import.meta.env.VITE_API_HOST_ALLOWLIST;
  if (raw == null || String(raw).trim() === '') return [];

  return String(raw)
    .split(',')
    .map(value => value.trim().toLowerCase())
    .filter(Boolean);
};

let cachedPatterns: string[] | null = null;

let getApiHostAllowlistPatterns = (): string[] => {
  if (cachedPatterns === null) {
    cachedPatterns = parseAllowlistFromEnv();
  }

  return cachedPatterns;
};

let matchesHostPattern = (hostname: string, pattern: string): boolean => {
  let normalizedHostname = hostname.trim().toLowerCase();
  let normalizedPattern = pattern.trim().toLowerCase();

  if (!normalizedHostname || !normalizedPattern) return false;

  if (normalizedPattern.startsWith('*.')) {
    let suffix = normalizedPattern.slice(2);
    if (!suffix) return false;
    return normalizedHostname.endsWith('.' + suffix);
  }

  return normalizedHostname === normalizedPattern;
};

export let getAllowedApiUrl = (value: string, fallbackUrl: string): string => {
  let candidate = value.trim();
  if (!candidate) return fallbackUrl;

  let parsed: URL;
  try {
    parsed = new URL(candidate);
  } catch {
    console.warn(`Ignoring invalid API URL query param: ${candidate}`);
    return fallbackUrl;
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    console.warn(`Ignoring API URL with unsupported protocol: ${candidate}`);
    return fallbackUrl;
  }

  let patterns = getApiHostAllowlistPatterns();
  if (
    patterns.length > 0 &&
    !patterns.some(pattern => matchesHostPattern(parsed.hostname, pattern))
  ) {
    console.warn(`Ignoring API URL outside configured allowlist: ${candidate}`);
    return fallbackUrl;
  }

  return parsed.href.replace(/\/$/, '');
};
